import { useSelector } from 'react-redux';

export const useUserProfile = () => {
  //@ts-ignore - there is no store in the package itself, hence the inability to type this properly
  const { config } = useSelector((state) => state.user);
  const { user_image_url: userImageUrl, profile } = config || {};
  const {
    forename: name,
    surname,
    username,
    email,
    company_title: title,
  } = profile || {};

  return {
    name,
    surname,
    username,
    email,
    title,
    imageUrl: userImageUrl,
  };
};
